import { useQuery } from "@apollo/client"
import { MenuItem } from "@blueprintjs/core"
import { debounce } from "lodash-es"
import React, { useState } from "react"
import StaticSelector from "../Atoms/StaticSelector"
const SearchSelector = ({ query, ...otherProps }) => {
  const [search, setQuery] = useState("")
  const { data, loading } = useQuery(query, {
    variables: {
      first: 15,
      query: search,
      filter: {
        ...otherProps?.filter,
      },
    },
  })

  const key = data && Object.keys(data)?.[0]
  const list = data?.[key]
  function handleChange(srch) {
    if (srch !== search) setQuery(srch)
  }
  const debouncedChange = debounce(handleChange, 500)
  return (
    <StaticSelector
      loading={loading}
      query={search}
      onQueryChange={debouncedChange}
      items={list}
      itemRenderer={(item, { handleClick, modifiers, index }) => {
        return (
          <MenuItem
            active={modifiers.active}
            key={item?.id ?? `item-${index}`}
            onClick={handleClick}
            text={item?.name}
          />
        )
      }}
      {...otherProps}
    />
  )
}

export default SearchSelector
